<template>
  <div class="content">
    <div class="table-page-operator-wrapper action-btn" >
      <a-button @click="handleTemplate" v-hasPermi="['scp:scpSopFcInitialDeliveryRatio:download']">下载模版</a-button>
      <a-button @click="$refs.importData.show()" type="primary" v-hasPermi="['scp:scpSopFcInitialDeliveryRatio:import']"
      >导入</a-button
      >
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpSopFcInitialDeliveryRatio:export']"
      >导出</a-button
      >
    </div>
    <a-spin :spinning="isLoading">
      <ls-api-table
        class="table"
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        rowKey="keyId"
        :scroll="{ fixScreen: true, x: 1300 }"
      >
        <!-- 操作 -->
        <span slot="operation" slot-scope="{ record, $index }">
          <a v-if="!isEdit || currentId !== record.keyId" @click="handleEdit(record, $index)" v-hasPermi="['scp:scpSopFcInitialDeliveryRatio:edit']">编辑</a>
          <a v-if="!isEdit || currentId !== record.keyId" class="ml10" @click="handleDelete(typeList, record)" v-hasPermi="['scp:scpSopFcInitialDeliveryRatio:remove']">删除</a>
          <a v-if="isEdit && currentId === record.keyId" @click="handleSave(record)">保存</a>
          <a v-if="isEdit && currentId === record.keyId" @click="handleCancel(record)" class="ml10">取消</a>
        </span>
        <template slot="month" slot-scope="{ record }">
          <span>{{ record.monthStart + '~' + record.monthEnd }}</span>
        </template>
        <template slot="updateTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="createTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="versionCode" slot-scope="{ record }">
          <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
        </template>
        <!-- 月份 -->
        <template slot="month" slot-scope="{ record, column }">
          <span v-if="!isEdit || currentId !== record.keyId">{{ record[column.dataIndex].initialDeliveryRatio+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.keyId"
            v-model="record[column.dataIndex].initialDeliveryRatio"
            size="small"
          />
        <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
        </template>
      </ls-api-table>
    </a-spin>
    <import-data
      ref="importData"
      :url="url"
      :sopDfcBasicDataId="queryParams.sopDfcBasicDataId"
      @handle-success="handleOk"
    />
  </div>
</template>

  <script>
import {
  apiScpSopFcInitialDeliveryRatioList,
  apiScpSopFcInitialDeliveryRatio,
  apiDelScpSopFcInitialDeliveryRatio
} from '@/api/scp/shipmentForecast/shipmentForecastSetting'
import { generateLsTableResData } from '@/utils/util.js'
import ImportData from './ImportData'

export default {
  components: {
    ImportData
    },
  props: {
    id: {
      type: String,
      default: '1' // 设置默认值为'Hello from child'
    }
  },
  data () {
    const id = this.id
    return {
      isLoading: false,
      url: '/scp/scpSopFcInitialDeliveryRatio/import',
      isEdit: false,
      tableList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpSopFcInitialDeliveryRatioList, true),
        pageCurrent: true
      },
      columns: [],
      columnsServe: [],
      // 表格字段
      columnsNative: [
        {
          title: '事业部',
          dataIndex: 'businessUnitDesc',
          width: 120,
          align: 'center'
        },
        {
          title: '软货标签及快递类型',
          dataIndex: 'sopSoftGoodsLabelExpressTypeDesc',
          width: 180,
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          width: 120,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          fixed: 'right',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 120,
          align: 'center'
        }
      ],
      queryParams: {
        sopDfcBasicDataId: id
      }
    }
  },
  methods: {
      /** 下载模板操作 */
      handleTemplate () {
      this.download('scp/scpSopFcInitialDeliveryRatio/download', {
        sopDfcBasicDataId: this.queryParams.sopDfcBasicDataId
      }, `期初发货比例模版_${new Date().getTime()}.xlsx`)
    },
        // 接口请求成功后回调
        successCallBack (myDataSource) {
          // debugger
        },
        /** 导出按钮操作 */
   handleExport () {
      this.download('scp/scpSopFcInitialDeliveryRatio/export', {
        sopDfcBasicDataId: this.id
      }, `期初发货比例_${new Date().getTime()}.xlsx`)
    },
   // 新增/修改框事件
     handleOk () {
        // this.onSearch()
      },
    handleDelete (tableList, record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          const ids = []
          self.columnsServe.forEach((column) => {
            console.log(column.indexKey)
            const id = record[column.indexKey].id
            ids.push(id)
          })
          apiDelScpSopFcInitialDeliveryRatio(ids).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑-保存
    handleSave (record) {
     // <!-- 行汇总必须为100% -->
     let count = 0
      for (const key in record) {
          if (key.includes('month')) {
            count = count + (record[key].initialDeliveryRatio ? record[key].initialDeliveryRatio : 0)
        }
      }
      if (!(count >= 95 && count <= 100)) {
        this.$message.error('行汇总必须为95%到100%之间')
        return
      }

      const recordCopy = JSON.parse(JSON.stringify(record))
      apiScpSopFcInitialDeliveryRatio(recordCopy).then((response) => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    getTableInfo (id) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      apiScpSopFcInitialDeliveryRatioList(id).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.tableList.forEach((obj, index) => {
            obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属性
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              dataIndex: title.indexKey,
              scopedSlots: { customRender: 'month' },
              width: 120,
              align: 'center'
            }
          })
          const dynamicColumn = this.setNewColumn('sopSoftGoodsLabelExpressTypeDesc', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
    // 表单搜索
    onSearch (params) {
      this.isEdit = false
       this.$refs.dataTable.searchParams = this.queryParams;
      // this.$refs.dataTable.getData();
      this.$refs.dataTable.myPagination.current = 1
      this.getTableInfo({ ...params,
        sopDfcBasicDataId: this.id,
       // businessUnit: params.businessUnit,
      //  sopSoftGoodsLabelExpressType: params.sopSoftGoodsLabelExpressType,
        pageSize: this.$refs.dataTable.myPagination.pageSize,
        pageNum: 1 })
    },
    /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
      return newArray
    },
    // 编辑
    handleEdit (record, index) {
      if (this.currentId && record.keyId !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.keyId
    }
  },
  created () {
    // this.getTableInfo()
  },
  mounted () {
    this.onSearch()
  }
}
</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
}
.action-btn {
  display: flex;
  padding: 8px 8px 8px 8px;
}
.table {
  flex: 1;
}
</style>
